import { CoreApiClient } from '../../core/client'
import type { PageResult } from '../../core/types'
import { withQuery } from '../../core/query'

/** 动态投影条目的渲染提示（与后端 FeedRenderType 枚举一致） */
export type AdminFeedRenderType = 'ARTICLE' | 'VIDEO' | 'DRAMA' | 'BUSINESS_CARD' | 'INTERACTION'

/** 动态投影条目的可见性状态（与后端 FeedEntryState 枚举一致） */
export type AdminFeedEntryState = 'VISIBLE' | 'WITHDRAWN'

/** 平台管理端跨租户动态清单条目（feed_entry_projection 只读视图） */
export interface AdminFeedEntry {
  tenantId: number
  tenantCode?: string | null
  tenantName?: string | null
  moduleCode: string
  moduleName?: string | null
  bizType: string
  sourceId: string
  renderType: AdminFeedRenderType
  entryState: AdminFeedEntryState
  publishedAt: string
  payloadSummary: string
  sourceVersion: number
}

export interface AdminFeedEntryQuery {
  tenantId?: number | null
  moduleCode?: string
  renderType?: AdminFeedRenderType | ''
  entryState?: AdminFeedEntryState | ''
  pageNo?: number
  pageSize?: number
}

/** 平台动态清单 API（M3 Task 4，只读） */
export class FeedApiModule {
  private readonly client: CoreApiClient

  constructor(client: CoreApiClient) {
    this.client = client
  }

  getAdminFeedEntries(query: AdminFeedEntryQuery = {}) {
    return this.client.get<PageResult<AdminFeedEntry>>(withQuery('/api/admin/feed/entries', query))
  }
}
